/* import __COLOCATED_TEMPLATE__ from './permissions.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();